// @flow
import * as React from 'react';
// $FlowFixMe
import { components } from 'react-select3';
import styled from 'styled-components';
import Dropdown from '../dropdown_select';
import { colors } from '../../constants';
import classNames from 'classnames';

const Option = (props) => {
  const [displayWrappedText, setDisplayWrappedText] = React.useState(false);
  const [timeoutId, setTimeoutId] = React.useState(null);

  const label = props.data && props.data.label;
  const description = props.data && props.data.description;
  return (
    <components.Option {...props}>
      <OptionContainer
        onMouseEnter={() => {
          const id = window.setTimeout(() => {
            setDisplayWrappedText(true);
          }, 300);
          setTimeoutId(id);
        }}
        onMouseLeave={() => {
          window.clearTimeout(timeoutId);
          setDisplayWrappedText(false);
        }}
      >
        {description ? (
          <>
            <OptionLabel
              className={classNames('option-label', {
                'display-wrapped-text': displayWrappedText,
              })}
            >
              {label}
            </OptionLabel>
            <OptionDescription
              className={classNames('option-description', {
                'display-wrapped-text': displayWrappedText,
              })}
            >
              {description || ''}
            </OptionDescription>
          </>
        ) : (
          label
        )}
      </OptionContainer>
    </components.Option>
  );
};

const MultiColumnDropdown = (props: any) => {
  return (
    <StyledDropdown isMulti isSearchable components={{ Option }} {...props} />
  );
};

export default MultiColumnDropdown;

const OptionLabel = styled.span`
  display: inline-block;
  width: 40%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 20px;
`;

const OptionDescription = styled.span`
  display: inline-block;
  width: 60%;
  color: ${colors.mediumGrey};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const OptionContainer = styled.div`
  display: flex;
  width: 100%;
`;

// $FlowFixMe
const StyledDropdown = styled(Dropdown)`
  .sl-dropdown__menu {
    min-width: 800px;
    border: 1px solid ${colors.lightGrey};
    box-shadow: 3px 3px 8px ${colors.lightGrey};
    border-radius: 3px;
    top: 98%;
  }

  && {
    .sl-dropdown__option {
      padding-left: 20px;
      height: auto;
      min-height: 36px;
    }
  }

  .option-description.display-wrapped-text,
  .option-label.display-wrapped-text {
    text-overflow: inherit;
    white-space: inherit;
    overflow: inherit;
  }
`;
